// extracted by mini-css-extract-plugin
export default {"NewsDateContainer":"NewsDate_NewsDateContainer__-T9eA","LightSubText":"NewsDate_LightSubText__wDAXz"};